import React, { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

import pages from 'pages';
import { NoMatch } from 'shared/components/NoMatch/NoMatch';
import { LoadingLogo } from 'shared/components/Modal/LoadingLogo';
import { AuthCopyAck } from 'admin/modules/auth-copy-ack/screens/AuthCopyAck';
import { Backfill } from 'admin/modules/backfill/screens/Backfill';
import { AgreementProfile } from 'admin/modules/agreements/screens/AgreementProfile';
import { AdminLayout as Layout } from './admin-layout';
import { InternalAdminGuard } from '../../guards/InternalAdminGuard';
import { SupportGuard } from '../../guards/SupportGuard';

const Agreements = lazy(() => import('admin/modules/agreements/screens/Agreements'));
const Admins = lazy(() => import('admin/modules/admins/screens/Admins'));
const ManageFaqs = lazy(() => import('admin/modules/manage-faqs/screens/ManageFaqs'));
const UserProfile = lazy(() => import('admin/modules/user-profile/screens/UserProfile'));
const Statistics = lazy(() => import('admin/modules/statistics/screens/Statistics'));

export const Admin: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: `${pages.ADMIN}/*`,
        children: [
          {
            index: true,
            element: <Navigate to={`/${pages.ADMIN}/${pages.AGREEMENTS}`} replace />,
          },
          {
            element: <SupportGuard />,
            children: [
              {
                path: pages.USER,
                element: (
                  <Suspense fallback={<LoadingLogo />}>
                    <UserProfile />
                  </Suspense>
                ),
              },
              {
                path: pages.AGREEMENTS,
                element: (
                  <Suspense fallback={<LoadingLogo />}>
                    <Agreements />
                  </Suspense>
                ),
              },
              { path: pages.AGREEMENT, element: <AgreementProfile /> },
              { path: pages.AGREEMENT_HOMEOWNER_CONTRACT_ID, element: <AgreementProfile /> },
              { path: pages.AGREEMENT_WORKFLOW_ID, element: <AgreementProfile /> },
            ],
          },

          {
            element: <InternalAdminGuard />,
            children: [
              {
                path: pages.ADMINS,
                element: (
                  <Suspense fallback={<LoadingLogo />}>
                    <Admins />
                  </Suspense>
                ),
              },
              {
                path: pages.STATISTICS,
                element: (
                  <Suspense fallback={<LoadingLogo />}>
                    <Statistics />,
                  </Suspense>
                ),
              },
              {
                path: pages.MANAGE_FAQS,
                element: (
                  <Suspense fallback={<LoadingLogo />}>
                    <ManageFaqs />
                  </Suspense>
                ),
              },
              {
                path: pages.AUTH_COPY_ACK,
                element: <AuthCopyAck />,
              },
              {
                path: pages.BACKFILL,
                element: <Backfill />,
              },
            ],
          },
        ],
        errorElement: <NoMatch />,
      },
    ],
  },
];

export default Admin;
